import { useSelector } from 'react-redux'

import { Spin } from 'antd'

// components
import ProfileSection from '../../profile'

// store
import { profileState } from '../../profile/profile.slice'

import styles from '../jobApplications.module.css'

const JobApplicantPersonalDetails = () => {
    const { status: profileStatus } = useSelector(profileState)

    return (
        <div className={styles.personalDetails}>
            <Spin spinning={profileStatus === 'loading' ? true : false}>
                <ProfileSection profileOpenKey="job" pageKeyProfile="job" />
            </Spin>
        </div>
    )
}

export default JobApplicantPersonalDetails
